import { ConfigurationPackage, Plan } from "./types";

export const MapProducts = (data: Plan[]) => {
  const configurationPackage = (
    pacote_configuracoes: ConfigurationPackage
  ): ConfigurationPackage | undefined => {
    return pacote_configuracoes;
  };

  return data.map((product) => {
    const config = configurationPackage(product.pacote_configuracoes);
    const packageFoundFlashSale = product.pacote_configuracoes?.flash_sale;
    const packageFoundPortability = product.pacote_configuracoes?.portability;
    const packageFoundDedicated = product.pacote_configuracoes?.dedicated;

    const shouldShowPortabilityBonus = config
      ? config.mostrar_bonus_portabilidade
      : true;
    const shouldShowDedicatedBonus = config
      ? config.mostrar_bonus_dedicado
      : true;

    const bonusPortabilidade = packageFoundPortability
      ? packageFoundPortability.gb
      : 0;

    const bonusDedicado = packageFoundDedicated ? packageFoundDedicated.gb : 0;

    let total =
      product.gb +
      (packageFoundFlashSale ? packageFoundFlashSale?.gb : 0);
    total += shouldShowPortabilityBonus ? bonusPortabilidade : 0;
    total += shouldShowDedicatedBonus ? bonusDedicado : 0;

    return {
      ...product,
      gb: total,
      gbPadrao: product.gb,
      gbBonusPortabilidade: bonusPortabilidade,
      bonusPortabilidade,
      gbPromocional: packageFoundFlashSale ? packageFoundFlashSale?.gb : 0,
      description: `${product.gb}GB
    ${
      packageFoundFlashSale
        ? `+ ${packageFoundFlashSale.gb}GB promocionais`
        : ""
    }`,
      mostrarPortabilidade: shouldShowPortabilityBonus,
      mostrarDedicado: shouldShowDedicatedBonus,
      gbBonusDedicated: bonusDedicado,
    };
  });
};
